import { Controller } from "@hotwired/stimulus";
import accessibleAutocomplete from "accessible-autocomplete";

export default class extends Controller {
  static targets = ["input", "results", "select", "container"];
  static values = {
    url: String,
    mode: String,
    initial: String,
    name: String,
    placeholder: String,
    fieldName: String,
    removeName: Boolean,
    required: Boolean,
  };

  connect() {
    if (this.modeValue === "existing") {
      this.setupExisting();
    } else {
      this.setupFree();
    }
  }

  setupExisting() {
    accessibleAutocomplete.enhanceSelectElement({
      selectElement: this.selectTarget,
      placeholder: this.placeholderValue || `Please select ${this.nameValue}`,
      autoselect: false,
      confirmOnBlur: false,
      showAllValues: true,
      required: this.requiredValue || false,
      name: this.fieldNameValue,
    });

    // Custom Fix for de-selection or selecting non-existing options due to upstream bug
    // this.fixSelectionBug();
  }

  fixSelectionBug() {
    this.validOptionLabels = new Set(
      Array.from(this.selectTarget.options)
        .map((o) => (o.textContent || "").trim())
        .filter((text) => text !== "")
    );

    const inputEl = this.selectTarget.parentNode.querySelector(
      "input.autocomplete__input"
    );
    if (inputEl) {
      inputEl.addEventListener("input", () => {
        const current = inputEl.value.trim();

        // Clear selection if current value is empty
        if (current === "") {
          this.clearSelection();
          return;
        }
        // Clear selection if current value is no longer a valid option label
        if (!this.validOptionLabels.has(current)) {
          if (this.selectTarget.value !== "") this.clearSelection();
        }
      });
    }
  }

  clearSelection() {
    this.selectTarget.value = "";
    Array.from(this.selectTarget.options).forEach((o) => {
      if (o.value !== "") o.selected = false;
    });
    this.selectTarget.dispatchEvent(new Event("change"));
  }

  setupFree() {
    const container = this.containerTarget;
    const initialValue = this.initialValue || "";

    accessibleAutocomplete({
      element: container,
      id: container.id,
      name: this.fieldNameValue,
      defaultValue: initialValue,
      source: (query, populate) => {
        fetch(`${this.urlValue}?query=${encodeURIComponent(query)}`)
          .then((r) => r.json())
          .then((list) => populate(list));
      },
      autoselect: false,
      confirmOnBlur: false,
      showAllValues: true,
      minLength: 0,
      required: this.hasRequiredValue ? this.requiredValue : true,
    });
  }
}
